import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    Chip,
    Box,
    Grid,
    Paper,
    Button,
    Tooltip,
    Avatar
} from '@mui/material';
import {
    Language,
    TheaterComedy,
    OpenInNew
} from '@mui/icons-material';
import { getImageUrlAdminToken } from '../../utills/ImagesUtilsAdmin';
import { generateAdminURL } from '../../utills/HelperUrl';
import { timeAgo } from '../../../utils/TimeFormat';

const ProjectCard = ({ projectContent, type }) => {
    const navigate = useNavigate();
    const theme = useTheme();

    //console.log('Image URL:', getImageUrlAdminToken(projectContent?.poster_image));

    // Helper function to format date (you might need to import this from your utils)
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    return (
        <Card
            elevation={0}

            sx={{
                // margin: '0 auto',
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                borderRadius: '8px',
                overflow: 'hidden',
                border: `1px solid ${theme.palette.divider}`,
            }}
        >

            <CardMedia
                sx={{
                    height: 250,
                    position: 'relative',
                    background: `${theme.palette.custom?.gradient || (theme.palette.mode === 'dark'
                        ? 'linear-gradient(to bottom, rgba(92, 94, 95, 0) 0%, rgba(70, 70, 70, 0.514) 50%, rgba(28, 28, 28, 1) 100%)'
                        : 'linear-gradient(to bottom, rgba(245, 245, 245, 0) 0%, rgba(200, 200, 200, 0.514) 50%, rgba(252, 252, 252, 1) 100%)')},
                        url("${getImageUrlAdminToken(projectContent?.poster_image)}") no-repeat`,
                    backgroundSize: 'cover',
                    objectPosition: 'top',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 5,
                        display: 'flex',
                        zIndex: 2,
                    }}
                >
                    <Tooltip title="Project Status By Admin" arrow placement='top'>
                        <Chip
                            clickable={false}
                            onClick={() => { }}
                            size="small"
                            variant="contained"
                            color="primary"
                            sx={{ textTransform: 'capitalize', fontSize: '0.75rem', }}
                            label={projectContent?.admin_project_status || 'Unknown Status'}
                        />
                    </Tooltip>
                </Box>

                <Box
                    sx={{
                        position: 'absolute',
                        bottom: 5,
                        left: 8,
                        display: 'flex',
                        gap: 1.5,
                        zIndex: 1,
                        flexWrap: 'wrap',
                    }}
                >

                    <Tooltip title=" Status" arrow placement='top'>

                        <Chip clickable={false}
                            onClick={() => { }}
                            size="small"
                            variant="outlined"
                            sx={{ textTransform: 'capitalize', backgroundColor: theme.palette.background.default, }}
                            label={projectContent?.project_status || 'Unknown Status'}

                        />
                    </Tooltip>


                    <Tooltip title="Project Type" arrow placement='top'>

                        <Chip clickable={false}
                            onClick={() => { }}
                            label={projectContent.work_project_type[0]?.project_type_name || 'Unknown Type'}
                            size="small"
                            variant="outlined"
                            sx={{ backgroundColor: theme.palette.background.default, }}
                        />
                    </Tooltip>
                </Box>
            </CardMedia>

            <CardContent sx={{ padding: 1, '&:last-child': { paddingBottom: 1 } }}>
                <Typography
                    variant="h6"
                    component="h1"
                    sx={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        lineClamp: 1,
                    }}
                >
                    {projectContent?.title || 'Untitled Project'}
                </Typography>

                {type !== 'Allpost' && (

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                        <Avatar
                            src={getImageUrlAdminToken(projectContent.user?.thumbnail_pic)}
                            alt={projectContent.user?.name || projectContent.creator?.name}
                            sx={{ width: 25, height: 25, cursor: 'pointer' }}
                            onClick={() => {
                                navigate(`/users/${projectContent.user_id}`);
                            }}
                        />
                        <div>
                            <Typography variant="body2"
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    flexGrow: 1,
                                    maxWidth: '200px',
                                }}
                            >
                                {projectContent.user?.name || projectContent.creator?.name || 'Unknown Creator'}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                                {timeAgo(projectContent.created_at)} ago
                            </Typography>
                        </div>
                    </Box>
                )}

                {/* <Typography
                    variant="body1"
                    component="div"
                    sx={{
                        marginBottom: '10px',
                    }}
                >
                    <ReadMoreText text={projectContent?.synopsis} maxLength={50} />
                </Typography> */}

                <Grid container spacing={1.5}>
                    <Grid size={{ xs: 12 }}>
                        <Paper
                            elevation={0}
                            variant='outlined'
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: theme.palette.background.default,

                                padding: '8px',
                                borderRadius: '10px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                },
                            }}
                        >
                            <Language sx={{ marginRight: '12px', fontSize: '20px', opacity: 0.8 }} />
                            <Typography variant="body2" sx={{
                                fontWeight: 600,
                                marginRight: '8px'
                            }}>
                                Language:
                            </Typography>
                            <Typography variant="body2">
                                {projectContent.languages?.map(lang =>
                                    typeof lang === 'object' ? lang.language : lang
                                ).join(', ') || 'N/A'}
                            </Typography>

                        </Paper>
                    </Grid>

                    <Grid size={{ xs: 12, }}>
                        <Paper
                            elevation={0}
                            variant='outlined'
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: theme.palette.background.default,
                                padding: '8px',
                                borderRadius: '10px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                },
                            }}
                        >
                            <TheaterComedy sx={{ marginRight: '12px', fontSize: '20px', opacity: 0.8 }} />
                            <Typography variant="body2" sx={{ fontWeight: 600, marginRight: '8px' }}>
                                Genres:
                            </Typography>
                            <Typography variant="body2"
                                sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', }}
                            >
                                {projectContent?.genres?.map(genre =>
                                    typeof genre === 'object' ? genre.name : genre
                                ).join(', ') || 'N/A'}
                            </Typography>
                        </Paper>
                    </Grid>

                    {/* start date and end date sane as Generes */}
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Paper
                            elevation={0}
                            variant='outlined'
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: theme.palette.background.default,
                                padding: '8px',
                                borderRadius: '10px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                },
                            }}
                        >
                            {/* <CalendarToday sx={{ marginRight: '12px', fontSize: '20px', opacity: 0.8 }} /> */}
                            <Typography variant="body2" color='text.primary' sx={{ fontSize: '0.75rem', marginRight: '1px', fontWeight: 600 }}>
                                Start Date:
                            </Typography>
                            <Typography variant="body2" color='text.secondary' >
                                {formatDate(projectContent?.start_date)}
                            </Typography>
                        </Paper>

                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Paper
                            elevation={0}
                            variant='outlined'
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: theme.palette.background.default,
                                padding: '8px',
                                borderRadius: '10px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                },
                            }}
                        >
                            {/* <CalendarToday sx={{ marginRight: '12px', fontSize: '20px', opacity: 0.8 }} /> */}
                            <Typography variant="body2" color="text.primary" sx={{ fontSize: '0.75rem', marginRight: '1px', fontWeight: 600 }}>
                                End Date:
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {formatDate(projectContent?.end_date)}
                            </Typography>
                        </Paper>
                    </Grid>

                </Grid>

                <Button
                    size="small"
                    variant="outlined"
                    sx={{ textTransform: 'none', marginTop: '10px' }}
                    startIcon={<OpenInNew />}
                    fullWidth
                    onClick={() => navigate(generateAdminURL('projects', projectContent.project_id, projectContent.title))}
                >
                    View Details
                </Button>
            </CardContent>
        </Card>
    );
};

export default ProjectCard;